//弹窗展示产品尺寸图
"use client";
import React, { useState } from "react";
import { sizeGuideClick } from "@/src/utils/gtagEvents";
import { FmButton, FmDrawer } from "@/ui-component";
import { useTranslation } from "@/src/i18n/client";
import stl from "../styles/sizechart.module.scss";
import classnames from "classnames";
import dynamic from "next/dynamic";
const SizeChartDrawer = dynamic(() => import("./SizeChartDrawer"));
interface IProps {
    productDetail: any;
    isShowSizeGuide: boolean;
}

const SizeChartClient: React.FC<React.PropsWithChildren<IProps>> = (props) => {
    const { t } = useTranslation("productDetail");
    const [sizeShow, setSizeShow] = useState(false);

    const toggleSizeShow = () => {
        setSizeShow((prev) => !prev);
    };

    const sizeGuide = () => {
        toggleSizeShow();
        sizeGuideClick();
    };

    return (
        <div className={stl["size-chart-page"]}>
            {props.isShowSizeGuide ? (
                <div onClick={toggleSizeShow}>{props.children}</div>
            ) : (
                <>
                    <p className={stl["size-title"]}>{`${t(
                        "productDetail:Size",
                    )}`}</p>
                    <FmButton onClick={sizeGuide} variant={"text"}>
                        {props.children}
                    </FmButton>
                </>
            )}
            <FmDrawer
                closeable={true}
                open={sizeShow}
                onClose={toggleSizeShow}
                headerChildren={
                    <div className={stl["header-content"]}>
                        {t("productDetail:SizeGuide")}
                    </div>
                }
                headerClassName={classnames(stl["size-show-header"])}
                closeablePosition={"right"}
                anchor={"bottom"}
                fullHeight
                className={stl["size-chart-container"]}
                childrenClassName={stl["size-chart-cotent"]}
            >
                {sizeShow && <SizeChartDrawer />}
            </FmDrawer>
        </div>
    );
};

export default SizeChartClient;
